import React, { useEffect, useRef, useState } from "react";
import "./PopUpComponent.css";

// harus sama dengan durasi animasi di PopUpComponent.css
const DURASI_ANIMASI = 250;

/**
 * open (opsional):
 *  - tidak diisi  -> perilaku lama (selalu tampil), animasi open tetap jalan
 *  - diisi true/false -> komponen tetap ter-mount selama animasi close,
 *    lalu hilang sendiri
 */
const PopUpComponent = ({
  children,
  style,
  small,
  scroll,
  className,
  open = true,
}) => {
  const [mounted, setMounted] = useState(open);
  const lastChildren = useRef(children);

  // simpan isi terakhir supaya tidak kosong saat animasi close
  if (open) lastChildren.current = children;

  useEffect(() => {
    if (open) {
      setMounted(true);
      return;
    }
    const timer = setTimeout(() => setMounted(false), DURASI_ANIMASI);
    return () => clearTimeout(timer);
  }, [open]);

  if (!open && !mounted) return null;

  const content = open ? children : lastChildren.current;

  return (
    <div
      className={`container_popup${!open ? " popup_closing" : ""}`}
      style={scroll ? { overflowY: "scroll" } : {}}
    >
      {!className ? (
        <div
          className={small ? "wrapper_popup width_popup" : "wrapper_popup"}
          style={style}
        >
          {content}
        </div>
      ) : (
        <div className={className} style={style}>
          {content}
        </div>
      )}
    </div>
  );
};
export default PopUpComponent;
